const langToCountryMap = {
  'sv': 'se'
}

const countryToLangMap = {
  'se': 'sv'
}

export default {
  languageToCountry (key) {
    return langToCountryMap[key] ? langToCountryMap[key] : key
  },

  countryToLanguage (key) {
    return countryToLangMap[key] ? countryToLangMap[key] : key
  }
}



// WEBPACK FOOTER //
// ./src/filters/iso3166/index.js